import constant from "./constant";
import { BiCheckShield } from "react-icons/bi";
import { IoListCircleOutline } from "react-icons/io5";
import { MdOutlineInventory } from "react-icons/md";
import { BsBoxArrowInDownLeft } from "react-icons/bs";
import { LuCalendarClock } from "react-icons/lu";

const FOOTER_ROUTES = {
    INVENTORY_AUDIT: "/inventory-audit",
    WARRANTY: "/warranty",
    PRODUCT_LIST: "/product/list",
    PENDING_RECEIPT: "/pending-receipt",
    TRANSFER_REQUEST: "/transfer-request",
  };

  // constants/routes.ts
  const FOOTER_LINKS = [
    { path: FOOTER_ROUTES.INVENTORY_AUDIT, Icon: MdOutlineInventory },
    { path: FOOTER_ROUTES.WARRANTY, Icon: BiCheckShield },
    { path: FOOTER_ROUTES.PRODUCT_LIST, Icon: IoListCircleOutline },
    { path: FOOTER_ROUTES.PENDING_RECEIPT, Icon: LuCalendarClock },
    { path: FOOTER_ROUTES.TRANSFER_REQUEST, Icon: BsBoxArrowInDownLeft },
  ];
  const PRODUCT_TYPE_OPTION = [
    { path: constant.PRODUCT_FILTER_TYPE.EYE_GLASSES, name: "Frame" },
    { path: constant.PRODUCT_FILTER_TYPE.SUN_GLASSES, name: "Sunglass" },
    { path: constant.PRODUCT_FILTER_TYPE.READING_GLASSES, name: "Reading" },
    { path: constant.PRODUCT_FILTER_TYPE.CONTACT_lENS, name: "Contact Lens" },
  ];

  export {
    FOOTER_ROUTES,
    FOOTER_LINKS,
    PRODUCT_TYPE_OPTION
  }